import styled from "styled-components";
import ThemeProvider from "./providers/ThemeProvider";
import { useDispatch } from "react-redux";
import { uiActions } from "./store/ui-slice";
import { Route } from "react-router-dom";
import Routes from "./routes/Routes";
import Notification from "./components/ui/Notification";
import { useSelector } from "react-redux";
import LoadingBackground from "./components/CircularLoader";
import React from "react";
import { SnackbarProvider } from 'notistack'
const Container = styled.div``;

function App() {
  const Logo = styled.img.attrs((props) => ({
    src: props.src,
  }))``;

  const dispatch = useDispatch();

  const toggleModal = () => {
    dispatch(uiActions.toggle());
  };

  const notification = useSelector((state) => state.ui.notification);
  const modalIsVisible = useSelector((state) => state.ui.modalIsVisible);
  const isRequestSending = useSelector((state) => state.ui.isRequestSending);


  return (
    <>
      <ThemeProvider>
        <SnackbarProvider maxSnack={2}>
          <Container>
            {modalIsVisible && (
              <Notification
                status={notification.status}
                title={notification.title}
                message={notification.message}
                show={modalIsVisible}
                setShow={toggleModal}
              />
            )}
            {isRequestSending && <LoadingBackground />}
            <Route path="/" component={Routes} />
          </Container>
        </SnackbarProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
